import {
  ref,
  inject,
  provide,
  getCurrentInstance,
  type App,
  nextTick,
} from 'vue'
import { useLocale as useElLocale } from 'element-plus'
import type { Language } from 'element-plus/es/locale'
const elLocaleModules = import.meta.glob(
  '/node_modules/element-plus/es/locale/lang/*.mjs',
)
let localeModules = import.meta.glob('../locale/lang/*.{mjs,ts}')
if (process.env.NODE_ENV === 'production') {
  localeModules = import.meta.glob(
    '/node_modules/el-plus/es/locale/lang/*.{mjs,ts}', // 打包后到vite项目,因为有optimizeDeps,会找不到, 所以要在生产环境下重新判断
  )
}
const TRANSLATER_KEY = Symbol('TRANSLATER_KEY')
export type Translater = (key: string) => string
let cachedTranslater: Translater | null = null
export const useLocale = () => {
  const localeLang = window.hxlang?.toLocaleLowerCase().split('_').join('-')
  const addLangClass = async (lang: string) => {
    await nextTick()
    const el = document.querySelector('html')
    const langclass = 'no-cn'
    if (el && lang !== 'ZH_CN') {
      el.classList.add(langclass)
    }
  }
  const inSetup = !!getCurrentInstance()
  const translater = inSetup ? inject<Translater>(TRANSLATER_KEY) : null
  if (translater) {
    cachedTranslater = translater
  }
  const loadLocale = (app?: App) => {
    const inSetup = !!getCurrentInstance()
    if (!inSetup && !app) {
      return console.error(
        'app is required when useLocale is called outside of setup',
      )
    }
    const provideFn = inSetup ? provide : app!.provide
    // eslint-disable-next-line no-async-promise-executor
    return new Promise<void>(async (resolve) => {
      try {
        let basePath = '../locale/lang/'
        if (process.env.NODE_ENV === 'production') {
          basePath = '/node_modules/el-plus/es/locale/lang/'
        }
        const ext = process.env.NODE_ENV === 'production' ? '.mjs' : '.ts'
        const modulePath = basePath + localeLang + ext
        let loader = localeModules[modulePath]
        if (!loader) {
          loader = localeModules[basePath + 'en' + ext]
        }
        const module = (await loader()) as { default: Language }
        const { t } = useElLocale(ref(module.default as unknown as Language))
        provideFn(TRANSLATER_KEY, t)
        resolve()
        addLangClass(window.hxlang!)
      } catch (error) {
        console.error(error)
      }
    })
  }
  const loadElLocale = async () => {
    const basePath = '/node_modules/element-plus/es/locale/lang/'
    const ext = '.mjs'
    const modulePath = basePath + localeLang + ext
    let loader = elLocaleModules[modulePath]
    if (!loader) {
      loader = elLocaleModules[basePath + 'en' + ext]
    }
    const module = (await loader()) as { default: Language }
    return module.default
  }
  return {
    loadLocale,
    loadElLocale,
    t: (key) => {
      // // 如果已经有缓存的 translater，直接使用
      if (cachedTranslater) {
        return cachedTranslater(key)
      }
      // const translater = inject<Translater>(TRANSLATER_KEY)
      if (translater) {
        // cachedTranslater = translater // 缓存起来
        return translater(key)
      }
      return key
    },
  }
}
